export class BusinessOrderSkuSerial {
    public id: number = 0;
    public code: string = '';

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
